import { styled } from "@mui/material";
import { LAYOUT } from "helpers/constants";
import { APP_HEADER_HEIGHT_CSS_VAR } from "helpers/headerLayout";

export const StyledWrapper = styled("div")`
  color: white;
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: calc(
    var(${APP_HEADER_HEIGHT_CSS_VAR}, 64px) + env(safe-area-inset-top, 0px)
  );
  margin-left: 0;
  @media (min-width: 900px) {
    margin-left: ${() => LAYOUT.DRAWER_WIDTH}px;
  }
`;

export const InnerWrapper = styled("div")(() => ({
  padding: "20px",
}));

export const MainContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  overflowX: "hidden",
  minHeight: "100dvh",
}));
